<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="page-container page-rewatch">
    <div class="row no-gutters w-100">
      <div class="col-12 col-md-2 col-lg-2 sidebar-wrapper">
        <app-tree-playback
          #cameraTree
          (onPlay)="findRecord($event)"
        ></app-tree-playback>
      </div>
      <div class="col-12 col-md-10 col-lg-10 content-wrapper">
        <div class="main-content">
          <div class="container">
            <div
              class="row py-3 row-control align-items-center justify-content-between flex-wrap"
            >
              <!-- Tiêu đề bên trái -->
              <div class="col-md-4 d-flex align-items-center mb-2 mb-md-0">
                <h1 class="page-title mb-0 fs-4">
                  <span>{{ "ldp_playback" | translate }}</span>
                  <span *ngIf="cameraSelected" class="text-muted">
                    / {{ cameraSelected.name }}</span
                  >
                </h1>
              </div>

              <!-- Bộ lọc và hành động bên phải -->
              <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                <label class="mb-0 me-2"
                  >{{ "ad_choose_timespan" | translate }}:</label
                >
                <div
                  class="datetime-range-picker-toggle cursor-pointer"
                  data-toggle="modal"
                  data-target="#selectDate"
                >
                  {{ startTime | date : "HH:mm dd/MM/y" }} -
                  {{ endTime | date : "HH:mm dd/MM/y" }}
                </div>
              </div>
            </div>

            <div
              *ngIf="cameraSelected && loading"
              class="load-data text-center"
              style="border-radius: 0; font-size: 18px"
            >
              <strong>{{ "ad_loading" | translate }}</strong>
              {{ "ad_waiting" | translate }}
            </div>
            <div
              class="card border-0 br-10 py-5"
              *ngIf="listRecord.length == 0 && cameraSelected && !loading"
            >
              <p class="text-center mb-0">{{ "ad_no_record" | translate }}</p>
            </div>
            <div *ngIf="!loading && listRecord.length > 0">
              <!-- <div *ngIf="selectedTypeView == 'One View'" class="video-item">
                <div class="video-frame" style="padding-bottom: unset">
                  <app-multivideojs
                    [camera]="cameraSelected"
                    [lstRecord]="listRecord"
                    #multivideojs
                    class="camera-media"
                  >
                  </app-multivideojs>
                  <div *ngIf="!multivideojs.loaded" class="startplay">
                    <a
                      class="icon icon-play"
                      (click)="playAllRecord(multivideojs)"
                      title="{{ 'ad_play_video' | translate }}"
                      href="javascript:;"
                    ></a>
                  </div>
                  <div *ngIf="multivideojs.loaded" class="meta">
                    <div style="display: inline-flex; width: 100%">
                      <a
                        *ngIf="isPause"
                        class="icon icon-play1"
                        (click)="play(multivideojs)"
                        title="{{ 'ad_play_video' | translate }}"
                        href="javascript:;"
                      ></a>
                      <a
                        *ngIf="!isPause"
                        class="icon icon-pause"
                        (click)="pause(multivideojs)"
                        title="{{ 'ad_pause' | translate }}"
                        href="javascript:;"
                      ></a>
                      <input
                        type="range"
                        min="0"
                        max="{{ totalTime }}"
                        value="0"
                        id="mySlider"
                        [(ngModel)]="time"
                        (input)="valueChanged($event, multivideojs)"
                        style="width: 100%; cursor: pointer"
                      />
                    </div>
                    <span class="video-time"
                      >{{ startTime?.getTime() | datex : "HH:mm DD/MM/YYYY" }} -
                      {{
                        endTime?.getTime() | datex : "HH:mm DD/MM/YYYY"
                      }}</span
                    >
                  </div>
                </div>
              </div> -->
              <div class="row">
                <div
                  class="col-12 col-md-4 mb-4"
                  *ngFor="
                    let record of listRecord;
                    trackBy: recordTrackById;
                    let i = index
                  "
                >
                  <div class="video-item border rounded shadow-sm p-2 h-100">
                    <div [id]="'record_' + record.id"
                      class="video-frame position-relative"
                      style="padding-bottom: unset"
                    >
                      <app-hlsjs
                        #videohls
                        [camera]="cameraSelected"
                        [type]="'PLAY_BACK'"
                        [record]="record"
                        class="camera-media w-100"
                      ></app-hlsjs>

                      <div
                        *ngIf="!videohls.loaded"
                        class="action position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50"
                      >
                        <a
                          class="icon icon-play text-white fs-3"
                          (click)="playRecord(videohls)"
                          title="{{ 'ad_play_video' | translate }}"
                          href="javascript:;"
                        ></a>
                      </div>
                      <div *ngIf="videohls.loaded" class="group-zoom small-icons">
                        <a
                          href="javascript:;"
                          (click)="Snapshot(videohls)"
                          title="{{ 'ad_snapshot' | translate }}"
                          ><i class="icon icon-snapshot"></i
                        ></a>
                        <a
                          href="javascript:;"
                          title="Phóng to"
                          (click)="setZoomIn(videohls)"
                        >
                          <i class="icon icon-view-zoomin"></i>
                        </a>
                        <a
                          href="javascript:;"
                          title="Thu nhỏ"
                          (click)="setZoomOut(videohls)"
                        >
                          <i class="icon icon-view-zoomout"></i>
                        </a>
                        <a
                          href="javascript:;"
                          title="{{ 'ad_fullscreen' | translate }}"
                        >
                         <i  class="icon" [ngClass]="{'icon-view-fullscreen':
                                fullscreenCameraId !== record.id,
                              'icon-view-smallscreen':
                                fullscreenCameraId === record.id
                            }"
                            (click)="fullscreen(videohls)"
                          ></i>
                          <!-- <i  class="icon icon-view-fullscreen"></i> -->
                        </a>
                      </div>
                    </div>

                    <div
                      class="meta mt-2 d-flex justify-content-between align-items-center"
                    >
                      <span class="video-time fw-semibold">
                        {{ record.startTime | datex : "HH:mm DD/MM/YYYY" }} -
                        {{ record.endTime | datex : "HH:mm DD/MM/YYYY" }}
                      </span>
                      <a
                        id="idDown"
                        class="icon icon-download ms-2"
                        (click)="downloadRecord(record.id, i)"
                        title="{{ 'ad_down' | translate }}"
                        href="javascript:;"
                      ></a>

                      <div *ngIf="progressVisible[i]" class="mt-2">
                        <p class="mb-1">Download file: {{ progressArr[i] }}%</p>
                        <progress
                          [value]="progressArr[i]"
                          max="100"
                          class="w-100"
                        ></progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="selectDate"
  tabindex="-1"
  role="dialog"
  aria-labelledby="selectDateTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered select-date-modal"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="selectDateTitle">
          {{ "ad_choose_timespan" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <i class="icon icon-close"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="selection-wrapper">
              <i class="icon icon-calendar"></i>
              <div class="form-group">
                <input
                  class="form-control"
                  id="select-date-first"
                  placeholder="{{ 'ad_enter_starttime' | translate }}"
                />
              </div>
            </div>
            <div class="selection-wrapper">
              <i class="icon icon-clock"></i>
              <div class="form-group">
                <div class="form-control-time">
                  <select
                    class="select-time d-inline-block"
                    id="select-hours-first"
                  >
                    <option
                      *ngFor="let h of hours; let i = index"
                      [value]="h"
                      [selected]="i == 0"
                    >
                      {{ h }}
                    </option>
                  </select>
                </div>
                <div class="form-control-time">
                  <select
                    class="select-time d-inline-block"
                    id="select-minutes-first"
                  >
                    <option
                      *ngFor="let m of minutes; let i = index"
                      [value]="m"
                      [selected]="i == 0"
                    >
                      {{ m }}
                    </option>
                  </select>
                </div>
                <div class="form-control-time">
                  <select
                    class="select-time d-inline-block"
                    id="select-ampm-first"
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="selection-wrapper">
              <i class="icon icon-calendar"></i>
              <div class="form-group">
                <input
                  class="form-control"
                  id="select-date-second"
                  placeholder="{{ 'ad_enter_endtime' | translate }}"
                />
              </div>
            </div>
            <div class="selection-wrapper">
              <i class="icon icon-clock"></i>
              <div class="form-group">
                <div class="form-control-time">
                  <select
                    class="select-time d-inline-block"
                    id="select-hours-second"
                  >
                    <option
                      *ngFor="let h of hours; let i = index"
                      [value]="h"
                      [selected]="i == 0"
                    >
                      {{ h }}
                    </option>
                  </select>
                </div>
                <div class="form-control-time">
                  <select
                    class="select-time d-inline-block"
                    id="select-minutes-second"
                  >
                    <option
                      *ngFor="let m of minutes; let i = index"
                      [value]="m"
                      [selected]="i == 0"
                    >
                      {{ m }}
                    </option>
                  </select>
                </div>
                <div class="form-control-time">
                  <select
                    class="select-time d-inline-block"
                    id="select-ampm-second"
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <input id="date-range-picker" />
            <div id="date-range-picker-container"></div>
          </div>
          <div class="col-12 form-action text-center mt-0">
            <button
              class="btn btn-outline-secondary mr-3"
              type="button"
              data-dismiss="modal"
            >
              {{ "li_cancel" | translate }}
            </button>
            <button
              class="btn btn-primary"
              type="button"
              (click)="findRecord(cameraSelected)"
            >
              {{ "ad_choose" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
